import { useMutation } from 'react-query';
import {useWordPressStore} from "../../store/wordpress.store";
import {WordpressApi} from "../../api/wordpress.api";

export const useWordPressPhotosFromActions = () => {
    const setPhotosFromActions = useWordPressStore((state) => state.setPhotosFromActions);

    return useMutation(WordpressApi.getPhotosFromActions, {
        onSuccess: (data) => {
            setPhotosFromActions(data);
        },
        onError: (error) => {
            console.error('Login failed:', error);
        },
    });
};